module.exports = __webpack_public_path__ + "1dcecd0ffca5ae2cf8a6b089e0691a71.svg";